import { combineReducers } from '@reduxjs/toolkit';
import { connectPrayerStreamUserSlice } from './async-action/connect-prayer-stream-user/connect-prayer-stream-user.slice';
import { getPrayerStreamUserRegistrationSlice } from './async-action/get-prayer-stream-user-registration/get-prayer-stream-user-registration.slice';
import { registerPrayerStreamUserSlice } from './async-action/register-prayer-stream-user/register-prayer-stream-user.slice';
import { updateUserGroupMembershipSlice } from './async-action/update-user-group-membership/update-user-group-membership.slice';
import { authSlice } from './auth/auth.slice';
import { errorSlice } from './error/error.slice';
import { streamSlice } from './stream/stream.slice';

export const reducer = combineReducers({
  asyncAction: combineReducers({
    connectPrayerStreamUser: connectPrayerStreamUserSlice.reducer,
    getPrayerStreamUserRegistration:
      getPrayerStreamUserRegistrationSlice.reducer,
    registerPrayerStreamUser: registerPrayerStreamUserSlice.reducer,
    updateUserGroupMembershipState: updateUserGroupMembershipSlice.reducer,
  }),
  auth: authSlice.reducer,
  error: errorSlice.reducer,
  stream: streamSlice.reducer,
});
